export const LANDING_PAGE = 'landingVIP';
export const APP_NAME_FOR_FPTI_LOGS = 'weasley';

export const FEATURE_GUEST_APPLE_PAY_SHOWN = 'FEATURE_GUEST_APPLE_PAY_SHOWN';
export const APPLE_PAY_IDENTITY_BUTTON_METRICS = {
  CLICK_COMPLETE: 'GUEST_SIGNUP.IDENTITY_PAY_WITH_APPLE_PAY_CLICKED.COMPLETE',
  CLICK_ERROR: 'GUEST_SIGNUP.IDENTITY_PAY_WITH_APPLE_PAY_CLICKED.ERROR',
} as const;
export const APPLE_PAY_PAYSHEET_ERROR = 'GUEST_SIGNUP.APPLE_PAY_PAYSHEET.ERROR';
